module.exports = __webpack_public_path__ + "static/media/recentSearch.13d7d474.svg";